import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { AppContextProvider } from '../../../../../Services/AppContext';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import ManagerWorkplaceWrapper from './ManagerWorkplaceWrapper';

loadDOMComponent({
	selector: 'react-workplace-management-wrapper',
	callback: ({ container }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<ManagerWorkplaceWrapper />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
